const locale = {
    placeholder: 'აირჩიეთ დრო',
    rangePlaceholder: ['საწყისი თარიღი', 'საბოლოო თარიღი'],
};
export default locale;
